<h3 class="text-primary font-weight-bold"></h3>
<section>
    <p>You have signed the Student Privacy acknowledgment. We thank you.</p>
    <p>
        <app-icon [type]="'lock-open'" class="mr-3 green"></app-icon> You can now assign lessons to
        your students and manage class rosters and assignments.
    </p>

    <div class="school-info">
        <p><b>School district: </b>{{ schoolDistrictName }}</p>
        <p><b>School: </b>{{ schoolName }}</p>
    </div>

    <app-data-privacy-support [formStackUrl]="formStackUrl"
        >Need to make a change? Let us know.</app-data-privacy-support
    >

    <div class="d-flex justify-content-center">
        <button
            type="button"
            class="btn btn-primary font-weight-bold font-size-14 px-4 py-2 mt-5"
            (click)="router.navigate([navUrl])"
        >
            {{ label }}
        </button>
    </div>
</section>
